export const enum STATUS_APPLICATION {
  NEW_APPLICATION = "new_application",
  IN_WORK = "in_work",
  ISSUED = "issued",
  REJECTED = "rejected",
  APPROVED = "approved",
  DRAFT = "draft",
  TO_REWORK = "to_rework",
  OFFER = "status_offer",
  REQUIRED_SIGNATURE = "required_signature",
}
